'use client';

import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import Button from '../../../Button/index.js';
import { Footer as Footer$1 } from '../../index.css.js';
import { useResumeModal } from '../../context/useResumeModal.js';
import { ETab } from '../../type.js';
import { IconBack } from '../../../LinkedIn/images.js';
import LoadingIcon from '../../../Images/LoadingIcon/index.js';
import { colors } from '../../../Colors/index.js';

var Footer = function (_a) {
    var handleClosePopup = _a.handleClosePopup, checkBeforeSubmitForm = _a.checkBeforeSubmitForm, onSaveContactInfo = _a.onSaveContactInfo, onSaveWoringPreference = _a.onSaveWoringPreference, workingPreferenceData = _a.workingPreferenceData, _b = _a.hiddenStep, hiddenStep = _b === void 0 ? 0 : _b;
    var _c = useResumeModal(), step = _c.step, setStep = _c.setStep, t = _c.t, isShowLoading = _c.isShowLoading;
    // {isShowLoading && <LoadingIcon bgColor={colors.grey[99]} />}
    var render = function () {
        switch (step) {
            case ETab.UPLOAD_CV:
                return (React__default.createElement(Footer$1.Tab, { tab: step },
                    React__default.createElement("div", { style: { marginRight: 'auto' } },
                        React__default.createElement("span", { style: { color: colors.grey[50] } }, t('Bạn chưa có sẵn hồ sơ đính kèm?')),
                        ' ',
                        React__default.createElement("a", { href: t('/ho-so') }, t('Cập nhật Hồ sơ VietnamWorks')))));
            case ETab.CONTACT_INFORMATION:
                return (React__default.createElement(Footer$1.Tab, { tab: step },
                    hiddenStep > 0 ? null : (React__default.createElement("div", { onClick: function () { return setStep(1); }, className: 'goBack' },
                        React__default.createElement(IconBack, null),
                        " ",
                        t('Hồ sơ đính kèm'))),
                    React__default.createElement("div", { style: { marginLeft: 'auto' } },
                        React__default.createElement(Button, { type: 'primary', onClick: function () {
                                onSaveContactInfo();
                            }, disabled: isShowLoading },
                            isShowLoading && React__default.createElement(LoadingIcon, { bgColor: colors.grey[80] }),
                            " ",
                            t('Tiếp tục')))));
            case ETab.WORKING_PREFERENCE:
                return (React__default.createElement(Footer$1.Tab, { tab: step },
                    hiddenStep > 1 ? null : (React__default.createElement("div", { onClick: function () { return setStep(2); }, className: 'goBack' },
                        React__default.createElement(IconBack, null),
                        " ",
                        t('Thông tin liên hệ'))),
                    React__default.createElement("div", { style: { marginLeft: 'auto' } },
                        React__default.createElement(Button, { type: 'primary', disabled: isShowLoading, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = workingPreferenceData &&
                                                checkBeforeSubmitForm;
                                            if (!_a) return [3 /*break*/, 2];
                                            return [4 /*yield*/, checkBeforeSubmitForm(workingPreferenceData)];
                                        case 1:
                                            _a = (_b.sent());
                                            _b.label = 2;
                                        case 2:
                                            if (_a) {
                                                // Hide loading overlay
                                                handleClosePopup();
                                                return [2 /*return*/];
                                            }
                                            onSaveWoringPreference();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } },
                            isShowLoading && React__default.createElement(LoadingIcon, { bgColor: colors.grey[80] }),
                            " ",
                            t('Lưu hồ sơ')))));
        }
        return React__default.createElement(React__default.Fragment, null);
    };
    return React__default.createElement(Footer$1.Container, null, render());
};

export { Footer as default };
//# sourceMappingURL=Footer.js.map
